import styled from "styled-components";
import { BackButton } from "./component";

export const StyledBackButton = styled(BackButton)`
  cursor: pointer;
`;
